import React from 'react';
import { Typography } from '@mui/material';

export const PageTitle: React.FC<{ children: React.ReactNode }> = (props) => {
    return (
        <Typography variant="h1" gutterBottom>{props.children}</Typography>
    );
};
